/* Sri Anu · Gold Customization page (gcx)
   Shared behaviour for every "Custom · " section:
   - arrow / dot carousels          ([data-gcx-car])
   - scroll reveal with a stagger   (.saj-scope.gcx bands)
   Safe to load once per page; re-runs for a single section in the theme editor. */
(function () {
  function initCarousel(sec) {
    if (sec.dataset.gcxCarReady === '1') return;
    sec.dataset.gcxCarReady = '1';
    var row = sec.querySelector('[data-gcx-row]');
    if (!row) return;
    var prev = sec.querySelector('[data-gcx-prev]'), next = sec.querySelector('[data-gcx-next]');
    var dots = sec.querySelector('[data-gcx-dots]');
    var items = [].slice.call(row.children);
    function step() { return items[0] ? items[0].getBoundingClientRect().width + 16 : row.clientWidth * 0.6; }
    function perView() { return Math.max(1, Math.round(row.clientWidth / step())); }

    if (dots && items.length) {
      var pages = Math.ceil(items.length / perView());
      dots.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('b');
        b.setAttribute('data-i', i);
        b.addEventListener('click', (function (idx) {
          return function () { row.scrollLeft = idx * perView() * step(); };
        })(i));
        dots.appendChild(b);
      }
    }
    function sync() {
      var max = row.scrollWidth - row.clientWidth - 2;
      if (prev) prev.disabled = row.scrollLeft <= 2;
      if (next) next.disabled = row.scrollLeft >= max;
      if (dots) {
        var idx = Math.round(row.scrollLeft / (perView() * step()));
        [].forEach.call(dots.children, function (d, i) { d.classList.toggle('on', i === idx); });
      }
    }
    if (prev) prev.addEventListener('click', function () { row.scrollLeft -= perView() * step(); });
    if (next) next.addEventListener('click', function () { row.scrollLeft += perView() * step(); });
    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* NOTE: the reveal class is added by JS on purpose - if JS never runs,
     everything stays visible instead of being stuck at opacity 0. */
  function initReveal(root) {
    if (root.dataset.gcxRvReady === '1') return;
    root.dataset.gcxRvReady = '1';
    if (!('IntersectionObserver' in window)) return;
    var groups = root.querySelectorAll('.gcx-hero-in, .gcx-b > .saj-container');
    if (!groups.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        [].slice.call(e.target.children).forEach(function (k, i) {
          setTimeout(function () { k.classList.add('in'); }, i * 90);
        });
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    groups.forEach(function (g) {
      [].slice.call(g.children).forEach(function (k) { k.classList.add('gcx-rv'); });
      io.observe(g);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-gcx-car]').forEach(initCarousel);
    (scope || document).querySelectorAll('.saj-scope.gcx').forEach(initReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  /* theme editor: a section that is added or re-rendered gets wired up again */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
